/*
 * A visit picked on the Patient Timeline of a chart with no visit today
 * (owner 10-09; CareIQTabN3.jsx): the timeline event becomes a card-shaped
 * visit the tab can show -- its date (the event's day), its provider, its
 * kind, and a status when the visit did not happen (visitGuard.js
 * visitStatusWord reads visit_confirmation). Encounter rows (the FHIR mirror)
 * carry no appointment id; a BlinkScribe-only row carries only its day.
 * Pure: unit tested in __tests__/noVisit.test.js.
 */
import { hasAppointmentId } from "../../../../../utils/visitGuard";

const STATUS = [
  [/^(CANCELL?ED|X|ENTERED-IN-ERROR)$/, "Cancelled"],
  [/^NO[\s_-]?SHOW$/, "No Show"],
  [/^RESCHEDULED$/, "Rescheduled"],
];

const statusOf = (raw) => {
  const st = String((raw && (raw.status || raw.appointmentstatus || raw.visit_confirmation)) || "").trim().toUpperCase();
  const hit = STATUS.find(([re]) => re.test(st));
  return hit ? hit[1] : "";
};

export const visitFromTimeline = (ev, patientId) => {
  const raw = (ev && ev.raw) || {};
  const day = ev && ev.date && typeof ev.date.format === "function" ? ev.date.format("YYYY-MM-DD") : String(raw.startdate || "").slice(0, 10);
  const prov = `${raw.providerfirstname || ""} ${raw.providerlastname || ""}`.trim()
    || String(raw.providername || raw.linked_provider || "").trim();
  return {
    patientid: patientId,
    appointmentid: hasAppointmentId(raw.appointmentid) ? Number(raw.appointmentid) : null,
    encounterid: raw.encounterid || "",
    startdate: day,
    providername: prov,
    purpose: String(raw.encountervisitname || raw.appointmenttypename || raw.encountertype || "Office Visit").trim(),
    visit_confirmation: statusOf(raw),
    departmentid: raw.departmentid,
    picked: "timeline",
  };
};
